import {
  RequiredToggle,
  ReadOnlyToggle,
} from 'apps/builder/components/settings/modal/shared'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { Input } from 'components/Input/Input'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { validateWholeInteger } from 'apps/builder/lib/input-validation'

export const RatingField = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue = '',
  style = style || 0,
  type,
  keyField,
}) => {
  const dispatch = useDispatch()

  const [valid, validate] = useState(true)
  const updateDefaultValue = value => {
    dispatch(
      updateEntry({
        guid,
        default: value,
      })
    )
  }

  const validateValue = value => {
    const validation = validateWholeInteger(value)
    validation ? validate(true) : validate(false)
    return validation
  }
  const change = input => {
    const isValid = validateValue(input)
    isValid ? updateDefaultValue(input) : ''
  }

  const inputProps = {
    id: `default-${guid}`,
    value: defaultValue || '',
    placeholder: ' ',
    error: !valid,
    update: change,
    label: 'Default Value',
    errorText: 'Input is invalid',
  }

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
          <div className="toggle-wrapper">
            <ReadOnlyToggle guid={guid} active={read_only} />
          </div>
        </div>
      </div>

      <div className="settings--default-value">
        <Input {...inputProps} />
      </div>
    </>
  )
}
